<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 隱藏 loading 動畫
    const preLoader = document.querySelector('#pre-loader')
    preLoader.style.display = 'none'

    // https://github.com/JakHuang/form-generator/issues/15
    document.body.ondrop = (event) => {
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>
